<script lang="ts">
  import { stopPropagation, preventDefault } from "./genericHandlers";
  import playIcon from "./assets/play.svg?raw";
  import stopIcon from "./assets/stop.svg?raw";
  import volumeOffIcon from "./assets/volume-off.svg?raw";
  import volumeOnIcon from "./assets/volume-on.svg?raw";
  import GuidedSceneSettings from "./GuidedSceneSettings.svelte";
  import { type SettingId } from "./lib/Settings";
  import { onMount } from "svelte";

  export let scene;
  export let isAmbiencePlaying;
  export let handlePlayAll;
  // export let handlePauseAll;
  export let handleStopAll;
  export let settingsChangedCallback: (
    setting: SettingId,
    newVal: any,
  ) => void;
  export let volumeChangeCallback: (newVolume: number) => void;

  let volume: HTMLInputElement;
  onMount(() => {
    volume.valueAsNumber = scene.globalVolume;
  });

  const handleVolumeChange = () => {
    volumeChangeCallback(volume.valueAsNumber);
  };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="scene-global-controls" on:click={preventDefault}>
  <div
    class="control-button volume-controls"
    on:pointerdown={stopPropagation}
    on:mousedown={stopPropagation}
  >
    {@html volumeOffIcon}
    <input
      class="soundcard-volume"
      id="volume-{scene.id}"
      type="range"
      min="0"
      max="100"
      on:change={handleVolumeChange}
      bind:this={volume}
    />
    {@html volumeOnIcon}
  </div>
  <GuidedSceneSettings {scene} {settingsChangedCallback}></GuidedSceneSettings>
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  {#if isAmbiencePlaying}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="contrast outline light control-button play-scene-button"
      on:pointerdown={stopPropagation}
      on:mousedown={stopPropagation}
      on:click={handleStopAll}
    >
      <span>Stop Scene</span>
      {@html stopIcon}
    </div>
  {:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
      class="contrast outline light control-button play-scene-button"
      on:pointerdown={stopPropagation}
      on:mousedown={stopPropagation}
      on:click={handlePlayAll}
    >
      Play Scene
      {@html playIcon}
    </div>
  {/if}
</div>
